import $ from 'jquery';

import { INSTANCE_NAMES, getInstance, setInstance } from '@retail/single-instance-cache';

import { SIZE, SizeHelper } from './SizeHelper';

export const getSizeHelper = (): SizeHelper => {
    let sizeHelper = getInstance<SizeHelper>(INSTANCE_NAMES.SIZE_HELPER);

    if (!sizeHelper) {
        sizeHelper = new SizeHelper();

        setInstance(INSTANCE_NAMES.SIZE_HELPER, sizeHelper);
    }

    return sizeHelper;
};

/**
 * Returns the current view size based on bootstrap breakpoints.
 * Creates html elements that are only visible for one size
 * and detects which one is actually visible
 */
export const getSize = (): string => {
    const $tester = $('<div></div>');
    const sizes = Object.values(SIZE);

    sizes.forEach((size) => {
        $tester.append($(`<div class="visible-${size}"></div>`));
    });

    $('body').append($tester);

    const visibleSizes = sizes.filter((size) => $tester.find(`.visible-${size}`).is(':visible'));

    $tester.remove();

    return visibleSizes[0];
};

export const updateSize = () => {
    const sizeHelper = getSizeHelper();
    const newSize = getSize();

    sizeHelper.size = newSize;
    sizeHelper.isMobile = [SIZE.SM, SIZE.XS].includes(newSize);
    sizeHelper.isRetina = window.devicePixelRatio > 1;
};
